import { render } from "./form-page.vue?vue&type=template&id=cdf4c69c&scoped=true"
import script from "./form-page.vue?vue&type=script&lang=js"
export * from "./form-page.vue?vue&type=script&lang=js"

import "./form-page.vue?vue&type=style&index=0&id=cdf4c69c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdf4c69c"]])

export default __exports__